import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { IUserGroup } from 'src/app/domain/registration/models/IUserGroup';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { UserGroupPermissionsComponent } from '../../user-group-permissions/user-group-permissions.component';
import { UserService } from '../../users/crud.service';
import {
  COLUMNS_TO_SHOW_MOBILE,
  TABLE_CONFIG_COLUMNS
} from '../crud-config';
import { UserGroupService } from '../crud-service';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-user-group-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [UserGroupService],
})
export class UserGroupCrudIndex
  extends AbstractCrudIndex<IUserGroup>
  implements ITableResponsive {
  override configColumns = TABLE_CONFIG_COLUMNS;
  override COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_MOBILE;
  override COLUMNS_TO_SHOW_WEB = COLUMNS_TO_SHOW_MOBILE;

  editParams = [
    'type',
    'systemActionCategory',
    'systemAction',
    'systemActionParam'
  ];
  public filterFormValues: any = null
  constructor(
    public override dialog: MatDialog,
    public override service: UserGroupService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public usersService: UserService,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.title = service.pluralTitle.toUpperCase();
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? this.COLUMNS_TO_SHOW_MOBILE
        : this.COLUMNS_TO_SHOW_WEB;
    });
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;

      this.loadDatasource(data);
    });
  }

  private loadDatasource(data: any) {
    this.dataSource = new MatTableDataSource<any>(
      data.map((item: any) => {

        item['hideEdit'] = !item.allowEdit;
        item['hideDelete'] = !item.allowDelete;
        // item.code = `${item.code}`.padStart(4, '0');
        // item.systemActionCategoryType = getSystemActionCategoryTypeDescriptionByValue(item?.systemAction?.systemActionCategory?.type);
        // item.systemAction = item?.systemAction?.name;
        return item;
      })
    );
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.loadDatasource(data);
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.name) params.name = filter.name.toUpperCase()
    else delete params.name;

    return params;
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  _openEdit($event: any) {
    this.router.navigate(['user-groups/edit', $event.id], {
      state: { editParams: this.editParams }
    });
  }

  _openNew($event: any) {
    this.router.navigate(['user-groups/new']);
  }

  _openShow($event: any) {
    this.router.navigate(['user-groups/show', $event.id]);
  }

  public openPermissions($event: any) {
    if (!$event) {
      this.toastService.showWarn('Selecione um tipo de usuário para configurar permissões.');
      return;
    }

    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: {
        // minWidth: '55%',
        width: '90%',
        height: 'auto',
        enterAnimationDuration: '500ms',
        exitAnimationDuration: '500ms',
        disableClose: false,
        panelClass: 'modal-panel',
      },
      component: UserGroupPermissionsComponent,
      data: { type: TypeIndexEnum.CRUD, select: true, element: $event },
      callBack: (data: any) => {
        // if (data?.element?.applied) this.deactiveProductsCloseFire.emit();
      },
    });
  }

  override onSelectionChange(selectionEvent: any) {
    console.log('[UserGroupCrudIndex] Seleção recebida:', selectionEvent);

    // Verificar se é um evento do tipo esperado (com selectAll) ou um evento padrão
    if (selectionEvent && 'selectAll' in selectionEvent) {
      // Formato esperado com selectAll
      if (selectionEvent.selectAll) {
        // Caso selectAll esteja ativo, manteremos a seleção vazia
        this.selection = { selected: [] };
      } else {
        // Caso selectAll não esteja ativo, usamos os itens selecionados
        this.selection = { selected: selectionEvent.items || [] };
      }
    } else if (selectionEvent && selectionEvent.source) {
      // Formato antigo onde recebemos o objeto selection diretamente
      this.selection = selectionEvent;
    } else {
      // Caso seja um evento genérico ou outro formato, apenas armazenar
      super.onSelectionChange(selectionEvent);
    }

    console.log('[UserGroupCrudIndex] Seleção processada:',
      this.selection?.selected?.length ? this.selection.selected.length : 0, 'item(s)');
  }
  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };

    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }
}
